

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis, Tooltip } from 'recharts';

interface AICostChartProps {
  chartData: { date: string; cost: number }[];
}

export function AICostChart({ chartData }: AICostChartProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>AI Cost Trends</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={350}>
          <BarChart data={chartData}>
            <XAxis 
              dataKey="date" 
              stroke="#888888" 
              fontSize={12} 
              tickLine={false} 
              axisLine={false}
            />
            <YAxis
              stroke="#888888"
              fontSize={12}
              tickLine={false}
              axisLine={false}
              tickFormatter={(value: number) => `$${value}`}
            />
            <Tooltip 
              formatter={(value: number) => [`$${Number(value).toFixed(2)}`, 'Cost']}
              labelFormatter={(label: string) => `Date: ${label}`}
            />
            <Bar dataKey="cost" fill="#3b82f6" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
